import * as angular from 'angular';
import {StateProvider} from '@uirouter/angularjs';
import DashboardController from "./DashboardController";

class Routes {
    static $inject = ['$stateProvider'];

    constructor($stateProvider: StateProvider) {
        $stateProvider
            .state('lead', {
                url: '/lead',
                abstract: true,
            })
            .state('lead.dashboard', {
                url: '/dashboard',
                template: require('./Dashboard.html'),
                controller: DashboardController,
                controllerAs: 'vm',
                data: {title: 'Lead Dashboard'}
            })


    }
}

export default angular.module('app.lead', [])
    .config(Routes)
    .name;
